import * as React from "react";
import { useEffect, useRef } from "react";
import "billboard.js/dist/billboard.css";
import "@reach/slider/styles.css";
import "react-next-dates/dist/style.scss";
import { StepResult } from "./app/stepResult";
import { App } from "./app/app";
import ReactRenderer from "../../resources/js/modules/_react-renderer";
import { IsPrintingAtom, TableAtom } from "./app/atoms";
import { useAtom } from "jotai";
import ReactDOM from "react-dom";
import { Table } from "./app/table";
import * as _ from "lodash/fp";

function wait(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function Print() {
  const ref = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const [print, setPrint] = useAtom(IsPrintingAtom);
  useEffect(() => {
    (async () => {
      if (!print) {
        return;
      }
      await wait(500);
      // Only needed for the PDF download, so they are loaded on demand
      const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
        import("html2canvas"),
        import("jspdf")
      ]);
      const params = await Promise.all([
        ref.current ? html2canvas(ref.current) : Promise.resolve(null),
        ref2.current ? html2canvas(ref2.current) : Promise.resolve(null),
        ref3.current ? html2canvas(ref3.current) : Promise.resolve(null)
      ]);

      const pdf = new jsPDF({ format: "a4" });

      const margin = {
        top: 10,
        bottom: 10,
        left: 10,
        right: 10
      };
      let pageHeight = pdf.internal.pageSize.getHeight();
      let pageWidth = pdf.internal.pageSize.getWidth();
      let innerPageHeight = pageHeight - margin.top - margin.bottom;
      let innerPageWidth = pageWidth - margin.left - margin.right;

      let imgPageTop = margin.top;
      for (const param of params.filter(Boolean)) {
        let ratio = innerPageWidth / param.width;
        let y = 0;
        if (imgPageTop + param.height * ratio > innerPageHeight) {
          pdf.addPage("a4", "portrait");
          imgPageTop = margin.top;
          y = imgPageTop;
        } else {
          y = imgPageTop;
          imgPageTop = imgPageTop + param.height * ratio;
        }
        const imgData = param.toDataURL("image/jpeg");
        pdf.addImage(
          imgData,
          "jpeg",
          margin.left,
          y,
          param.width * ratio,
          param.height * ratio
        );
      }

      pdf.save("download.pdf");
      setPrint(() => false);
    })();
  }, []);
  const [tableRows] = useAtom(TableAtom);
  return (
    <>
      <div className="analysis-tool-pdf">
        <div className="analysis-tool-pdf__inner">
          <StepResult ref={ref} />
          <Table ref={ref2} tableRows={_.take(15, tableRows)} />
          <Table ref={ref3} tableRows={_.drop(15, tableRows)} />
        </div>
      </div>
      {ReactDOM.createPortal(
        <div className="analysis-tool-spinner"></div>,
        document.body
      )}
    </>
  );
}

function AnalysisTool() {
  const [print] = useAtom(IsPrintingAtom);
  if (print) {
    return <Print />;
  }
  return <App />;
}

ReactRenderer.registerComponent("AnalysisTool", AnalysisTool);
